import React from 'react'
import { Appbar } from 'react-native-paper'
import { StackHeaderProps } from '@react-navigation/stack'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'react-native-paper'
import { View, Text } from 'react-native'
import { useIsMobileDevice } from '../../../../hooks/is-mobile.hook'
import { Cluster } from '../perspective-cards/types'
import { alignBrowserWidth } from '../../../../utils/browser'
import { Link, MelddButton } from '../../../../@ui'
import { Theme } from '../../../../utils/theme'

export interface CreateArticleHeaderProps extends StackHeaderProps {
  cluster?: Cluster
  onCancel?: () => void
  onPublish?: () => void
  loading?: boolean
}

export function CreateArticleHeader({
  cluster,
  onCancel,
  onPublish,
  loading = false,
  navigation,
}: CreateArticleHeaderProps) {
  const { t } = useTranslation('articles')
  const theme = useTheme()
  const isMobile = useIsMobileDevice()

  return (
    <Appbar.Header
      style={{
        backgroundColor: theme.colors.secondaryContainer,
      }}
    >
      <View style={{ flex: 1, alignItems: 'center' }}>
        <View
          style={{
            width: alignBrowserWidth(),
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingHorizontal: 8,
            columnGap: 8,
          }}
        >
          <Link
            text={t('Cancel')}
            onPress={onCancel || (() => navigation?.goBack())}
            disabled={loading}
          />

          <View style={{ flex: 1, alignItems: 'center' }}>
            <Text
              style={{
                fontSize: isMobile ? 16 : 24,
                fontWeight: isMobile ? '400' : '600',
                color: theme.colors.onSurface,
              }}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {cluster?.topic || ''}
            </Text>
          </View>

          <MelddButton
            onPress={onPublish || (() => {})}
            isLoading={loading}
            color={Theme.color.primary.main}
            textColor="white"
            title={t('Publish')}
            fontSize={isMobile ? 12 : 16}
            height={isMobile ? 28 : 32}
          />
        </View>
      </View>
    </Appbar.Header>
  )
}
